import {Injectable} from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class GlobalService {
    private generals: any;
    private customers: Array<any>;

    public setGenerals(generals: any) {
        this.generals = generals;
    }

    public getGenerals() {
        return this.generals;
    }

    public setCustomers(customers: Array<any>) {
        this.customers = customers;
    }

    public getCustomers() {
        return this.customers || [];
    }
}
